export function getMonday(date?: Date): string {
  const d = date ? new Date(date) : new Date();
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function shiftWeek(isoDate: string, delta: number): string {
  const d = new Date(isoDate);
  d.setDate(d.getDate() + delta * 7);
  return d.toISOString();
}

export function formatWeekRange(mondayISO: string): string {
  const mon = new Date(mondayISO);
  const sun = new Date(mondayISO);
  sun.setDate(sun.getDate() + 6);
  const monStr = mon.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const sunStr = sun.toLocaleDateString('en-US', { day: 'numeric' });
  return `${monStr}–${sunStr}`;
}

export function isCurrentWeek(mondayISO: string): boolean {
  return mondayISO === getMonday();
}

/** Week range with year, handling month-crossing weeks: "Oct 12–19, 2026" or "Sep 28–Oct 5, 2026". */
export function formatWeekRangeYear(mondayISO: string): string {
  const mon = new Date(mondayISO);
  const sun = new Date(mondayISO);
  sun.setDate(sun.getDate() + 6);
  const sameMonth = mon.getMonth() === sun.getMonth();
  const monStr = mon.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const sunStr = sun.toLocaleDateString('en-US', sameMonth ? { day: 'numeric' } : { month: 'short', day: 'numeric' });
  return `${monStr}–${sunStr}, ${sun.getFullYear()}`;
}

/** Verbose week range for chart tooltips: "Mar 30 to Apr 5, 2026". Omits start year when same as end year. */
export function formatWeekRangeFull(startIso: string, endIso: string): string {
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    const fallback = (iso: string) => {
      const d = new Date(iso);
      return Number.isNaN(d.getTime())
        ? iso
        : d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
    };
    return `${fallback(startIso)} to ${fallback(endIso)}`;
  }
  const sameYear = start.getFullYear() === end.getFullYear();
  const startText = start.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
    timeZone: 'UTC',
  });
  const endText = end.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
  return `${startText} to ${endText}`;
}
